// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./assets/css/typography.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles.css */
/* ! tailwindcss v3.4.3 | MIT License | https://tailwindcss.com */
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 1rem;
  padding-left: 1rem;
}
@media (min-width: 500px) {
  .container {
    max-width: 500px;
  }
}
@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1440px) {
  .container {
    max-width: 1440px;
  }
}
@media (min-width: 1921px) {
  .container {
    max-width: 1921px;
  }
}
#agency-roster-root :is(.pointer-events-none) {
  pointer-events: none;
}
#agency-roster-root :is(.\\!visible) {
  visibility: visible !important;
}
#agency-roster-root :is(.visible) {
  visibility: visible;
}
#agency-roster-root :is(.invisible) {
  visibility: hidden;
}
#agency-roster-root :is(.fixed) {
  position: fixed;
}
#agency-roster-root :is(.absolute) {
  position: absolute;
}
#agency-roster-root :is(.relative) {
  position: relative;
}
#agency-roster-root :is(.inset-0) {
  inset: 0px;
}
#agency-roster-root :is(.-bottom-2) {
  bottom: -0.5rem;
}
#agency-roster-root :is(.-bottom-8) {
  bottom: -2rem;
}
#agency-roster-root :is(.-right-2) {
  right: -0.5rem;
}
#agency-roster-root :is(.bottom-\\[102\\%\\]) {
  bottom: 102%;
}
#agency-roster-root :is(.bottom-full) {
  bottom: 100%;
}
#agency-roster-root :is(.left-0) {
  left: 0px;
}
#agency-roster-root :is(.left-1\\/2) {
  left: 50%;
}
#agency-roster-root :is(.right-0) {
  right: 0px;
}
#agency-roster-root :is(.right-\\[12px\\]) {
  right: 12px;
}
#agency-roster-root :is(.right-\\[38px\\]) {
  right: 38px;
}
#agency-roster-root :is(.right-\\[48px\\]) {
  right: 48px;
}
#agency-roster-root :is(.top-0) {
  top: 0px;
}
#agency-roster-root :is(.top-\\[102\\%\\]) {
  top: 102%;
}
#agency-roster-root :is(.top-full) {
  top: 100%;
}
#agency-roster-root :is(.z-1) {
  z-index: 1;
}
#agency-roster-root :is(.z-10) {
  z-index: 10;
}
#agency-roster-root :is(.z-50) {
  z-index: 50;
}
#agency-roster-root :is(.z-\\[1000\\]) {
  z-index: 1000;
}
#agency-roster-root :is(.z-\\[3333\\]) {
  z-index: 3333;
}
#agency-roster-root :is(.z-\\[9999\\]) {
  z-index: 9999;
}
#agency-roster-root :is(.z-\\[999\\]) {
  z-index: 999;
}
#agency-roster-root :is(.col-span-10) {
  grid-column: span 10 / span 10;
}
#agency-roster-root :is(.mx-1) {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
#agency-roster-root :is(.mx-10) {
  margin-left: 2.5rem;
  margin-right: 2.5rem;
}
#agency-roster-root :is(.mx-2) {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
#agency-roster-root :is(.mx-\\[58px\\]) {
  margin-left: 58px;
  margin-right: 58px;
}
#agency-roster-root :is(.mx-auto) {
  margin-left: auto;
  margin-right: auto;
}
#agency-roster-root :is(.my-6) {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
#agency-roster-root :is(.-mb-1) {
  margin-bottom: -0.25rem;
}
#agency-roster-root :is(.-mt-1) {
  margin-top: -0.25rem;
}
#agency-roster-root :is(.-mt-\\[320px\\]) {
  margin-top: -320px;
}
#agency-roster-root :is(.mb-1) {
  margin-bottom: 0.25rem;
}
#agency-roster-root :is(.mb-10) {
  margin-bottom: 2.5rem;
}
#agency-roster-root :is(.mb-12) {
  margin-bottom: 3rem;
}
#agency-roster-root :is(.mb-16) {
  margin-bottom: 4rem;
}
#agency-roster-root :is(.mb-2) {
  margin-bottom: 0.5rem;
}
#agency-roster-root :is(.mb-3) {
  margin-bottom: 0.75rem;
}
#agency-roster-root :is(.mb-4) {
  margin-bottom: 1rem;
}
#agency-roster-root :is(.mb-6) {
  margin-bottom: 1.5rem;
}
#agency-roster-root :is(.mb-7) {
  margin-bottom: 1.75rem;
}
#agency-roster-root :is(.mb-8) {
  margin-bottom: 2rem;
}
#agency-roster-root :is(.mb-\\[24px\\]) {
  margin-bottom: 24px;
}
#agency-roster-root :is(.mb-\\[54px\\]) {
  margin-bottom: 54px;
}
#agency-roster-root :is(.mb-\\[72px\\]) {
  margin-bottom: 72px;
}
#agency-roster-root :is(.ml-2) {
  margin-left: 0.5rem;
}
#agency-roster-root :is(.mr-14) {
  margin-right: 3.5rem;
}
#agency-roster-root :is(.mr-2) {
  margin-right: 0.5rem;
}
#agency-roster-root :is(.mt-1) {
  margin-top: 0.25rem;
}
#agency-roster-root :is(.mt-10) {
  margin-top: 2.5rem;
}
#agency-roster-root :is(.mt-2) {
  margin-top: 0.5rem;
}
#agency-roster-root :is(.mt-4) {
  margin-top: 1rem;
}
#agency-roster-root :is(.mt-64) {
  margin-top: 16rem;
}
#agency-roster-root :is(.mt-\\[47px\\]) {
  margin-top: 47px;
}
#agency-roster-root :is(.mt-\\[72px\\]) {
  margin-top: 72px;
}
#agency-roster-root :is(.block) {
  display: block;
}
#agency-roster-root :is(.inline-block) {
  display: inline-block;
}
#agency-roster-root :is(.inline) {
  display: inline;
}
#agency-roster-root :is(.flex) {
  display: flex;
}
#agency-roster-root :is(.inline-flex) {
  display: inline-flex;
}
#agency-roster-root :is(.table) {
  display: table;
}
#agency-roster-root :is(.grid) {
  display: grid;
}
#agency-roster-root :is(.hidden) {
  display: none;
}
#agency-roster-root :is(.size-2) {
  width: 0.5rem;
  height: 0.5rem;
}
#agency-roster-root :is(.size-5) {
  width: 1.25rem;
  height: 1.25rem;
}
#agency-roster-root :is(.h-10) {
  height: 2.5rem;
}
#agency-roster-root :is(.h-12) {
  height: 3rem;
}
#agency-roster-root :is(.h-2) {
  height: 0.5rem;
}
#agency-roster-root :is(.h-2\\.5) {
  height: 0.625rem;
}
#agency-roster-root :is(.h-20) {
  height: 5rem;
}
#agency-roster-root :is(.h-4) {
  height: 1rem;
}
#agency-roster-root :is(.h-5) {
  height: 1.25rem;
}
#agency-roster-root :is(.h-8) {
  height: 2rem;
}
#agency-roster-root :is(.h-\\[11px\\]) {
  height: 11px;
}
#agency-roster-root :is(.h-\\[136px\\]) {
  height: 136px;
}
#agency-roster-root :is(.h-\\[160px\\]) {
  height: 160px;
}
#agency-roster-root :is(.h-\\[1px\\]) {
  height: 1px;
}
#agency-roster-root :is(.h-\\[20px\\]) {
  height: 20px;
}
#agency-roster-root :is(.h-\\[213px\\]) {
  height: 213px;
}
#agency-roster-root :is(.h-\\[24px\\]) {
  height: 24px;
}
#agency-roster-root :is(.h-\\[72px\\]) {
  height: 72px;
}
#agency-roster-root :is(.h-full) {
  height: 100%;
}
#agency-roster-root :is(.max-h-60) {
  max-height: 15rem;
}
#agency-roster-root :is(.max-h-\\[311px\\]) {
  max-height: 311px;
}
#agency-roster-root :is(.max-h-\\[90vh\\]) {
  max-height: 90vh;
}
#agency-roster-root :is(.min-h-\\[118px\\]) {
  min-height: 118px;
}
#agency-roster-root :is(.w-1\\/2) {
  width: 50%;
}
#agency-roster-root :is(.w-12) {
  width: 3rem;
}
#agency-roster-root :is(.w-2) {
  width: 0.5rem;
}
#agency-roster-root :is(.w-2\\.5) {
  width: 0.625rem;
}
#agency-roster-root :is(.w-4) {
  width: 1rem;
}
#agency-roster-root :is(.w-5) {
  width: 1.25rem;
}
#agency-roster-root :is(.w-8) {
  width: 2rem;
}
#agency-roster-root :is(.w-\\[150\\%\\]) {
  width: 150%;
}
#agency-roster-root :is(.w-\\[15px\\]) {
  width: 15px;
}
#agency-roster-root :is(.w-\\[1px\\]) {
  width: 1px;
}
#agency-roster-root :is(.w-\\[24px\\]) {
  width: 24px;
}
#agency-roster-root :is(.w-fit) {
  width: -moz-fit-content;
  width: fit-content;
}
#agency-roster-root :is(.w-full) {
  width: 100%;
}
#agency-roster-root :is(.w-max) {
  width: max-content;
}
#agency-roster-root :is(.min-w-\\[220px\\]) {
  min-width: 220px;
}
#agency-roster-root :is(.min-w-\\[40px\\]) {
  min-width: 40px;
}
#agency-roster-root :is(.min-w-\\[638px\\]) {
  min-width: 638px;
}
#agency-roster-root :is(.max-w-\\[1016px\\]) {
  max-width: 1016px;
}
#agency-roster-root :is(.max-w-\\[1231px\\]) {
  max-width: 1231px;
}
#agency-roster-root :is(.max-w-\\[1440px\\]) {
  max-width: 1440px;
}
#agency-roster-root :is(.max-w-\\[160px\\]) {
  max-width: 160px;
}
#agency-roster-root :is(.max-w-\\[240px\\]) {
  max-width: 240px;
}
#agency-roster-root :is(.max-w-\\[350px\\]) {
  max-width: 350px;
}
#agency-roster-root :is(.max-w-\\[385\\.5px\\]) {
  max-width: 385.5px;
}
#agency-roster-root :is(.max-w-\\[432px\\]) {
  max-width: 432px;
}
#agency-roster-root :is(.max-w-\\[568px\\]) {
  max-width: 568px;
}
#agency-roster-root :is(.max-w-\\[762px\\]) {
  max-width: 762px;
}
#agency-roster-root :is(.max-w-\\[827px\\]) {
  max-width: 827px;
}
#agency-roster-root :is(.max-w-\\[972px\\]) {
  max-width: 972px;
}
#agency-roster-root :is(.flex-1) {
  flex: 1 1;
}
#agency-roster-root :is(.flex-shrink-0) {
  flex-shrink: 0;
}
#agency-roster-root :is(.grow) {
  flex-grow: 1;
}
#agency-roster-root :is(.basis-full) {
  flex-basis: 100%;
}
#agency-roster-root :is(.-translate-x-1\\/2) {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#agency-roster-root :is(.-rotate-180) {
  --tw-rotate: -180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#agency-roster-root :is(.-rotate-45) {
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#agency-roster-root :is(.rotate-45) {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#agency-roster-root :is(.transform) {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
#agency-roster-root :is(.animate-shimmer) {
  animation: shimmer 1.8s infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
#agency-roster-root :is(.animate-spin) {
  animation: spin 1s linear infinite;
}
#agency-roster-root :is(.cursor-not-allowed) {
  cursor: not-allowed;
}
#agency-roster-root :is(.cursor-pointer) {
  cursor: pointer;
}
#agency-roster-root :is(.select-all) {
  -webkit-user-select: all;
          user-select: all;
}
#agency-roster-root :is(.resize-none) {
  resize: none;
}
#agency-roster-root :is(.resize) {
  resize: both;
}
#agency-roster-root :is(.appearance-none) {
  appearance: none;
}
#agency-roster-root :is(.grid-cols-3) {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
#agency-roster-root :is(.flex-row) {
  flex-direction: row;
}
#agency-roster-root :is(.flex-col) {
  flex-direction: column;
}
#agency-roster-root :is(.place-items-center) {
  place-items: center;
}
#agency-roster-root :is(.items-start) {
  align-items: flex-start;
}
#agency-roster-root :is(.items-center) {
  align-items: center;
}
#agency-roster-root :is(.justify-end) {
  justify-content: flex-end;
}
#agency-roster-root :is(.justify-center) {
  justify-content: center;
}
#agency-roster-root :is(.justify-between) {
  justify-content: space-between;
}
#agency-roster-root :is(.gap-1) {
  gap: 0.25rem;
}
#agency-roster-root :is(.gap-2) {
  gap: 0.5rem;
}
#agency-roster-root :is(.gap-3) {
  gap: 0.75rem;
}
#agency-roster-root :is(.gap-4) {
  gap: 1rem;
}
#agency-roster-root :is(.gap-\\[28\\.5px\\]) {
  gap: 28.5px;
}
#agency-roster-root :is(.gap-x-1) {
  column-gap: 0.25rem;
}
#agency-roster-root :is(.gap-x-4) {
  column-gap: 1rem;
}
#agency-roster-root :is(.gap-x-6) {
  column-gap: 1.5rem;
}
#agency-roster-root :is(.gap-x-\\[10px\\]) {
  column-gap: 10px;
}
#agency-roster-root :is(.gap-x-\\[3px\\]) {
  column-gap: 3px;
}
#agency-roster-root :is(.gap-y-2) {
  row-gap: 0.5rem;
}
#agency-roster-root :is(.gap-y-4) {
  row-gap: 1rem;
}
#agency-roster-root :is(.gap-y-6) {
  row-gap: 1.5rem;
}
#agency-roster-root :is(.self-start) {
  align-self: flex-start;
}
#agency-roster-root :is(.overflow-hidden) {
  overflow: hidden;
}
#agency-roster-root :is(.overflow-y-auto) {
  overflow-y: auto;
}
#agency-roster-root :is(.overflow-x-hidden) {
  overflow-x: hidden;
}
#agency-roster-root :is(.text-ellipsis) {
  text-overflow: ellipsis;
}
#agency-roster-root :is(.whitespace-nowrap) {
  white-space: nowrap;
}
#agency-roster-root :is(.whitespace-pre-wrap) {
  white-space: pre-wrap;
}
#agency-roster-root :is(.text-wrap) {
  text-wrap: wrap;
}
#agency-roster-root :is(.text-nowrap) {
  text-wrap: nowrap;
}
#agency-roster-root :is(.rounded) {
  border-radius: 0.25rem;
}
#agency-roster-root :is(.rounded-6) {
  border-radius: 6px;
}
#agency-roster-root :is(.rounded-8) {
  border-radius: 8px;
}
#agency-roster-root :is(.rounded-\\[16px\\]) {
  border-radius: 16px;
}
#agency-roster-root :is(.rounded-\\[1px\\]) {
  border-radius: 1px;
}
#agency-roster-root :is(.rounded-\\[2px\\]) {
  border-radius: 2px;
}
#agency-roster-root :is(.rounded-\\[38px\\]) {
  border-radius: 38px;
}
#agency-roster-root :is(.rounded-\\[40px\\]) {
  border-radius: 40px;
}
#agency-roster-root :is(.rounded-full) {
  border-radius: 9999px;
}
#agency-roster-root :is(.rounded-lg) {
  border-radius: 0.5rem;
}
#agency-roster-root :is(.rounded-md) {
  border-radius: 0.375rem;
}
#agency-roster-root :is(.rounded-xl) {
  border-radius: 0.75rem;
}
#agency-roster-root :is(.rounded-b-\\[16px\\]) {
  border-bottom-right-radius: 16px;
  border-bottom-left-radius: 16px;
}
#agency-roster-root :is(.rounded-t-\\[16px\\]) {
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}
#agency-roster-root :is(.border) {
  border-width: 1px;
}
#agency-roster-root :is(.border-2) {
  border-width: 2px;
}
#agency-roster-root :is(.border-4) {
  border-width: 4px;
}
#agency-roster-root :is(.border-solid) {
  border-style: solid;
}
#agency-roster-root :is(.border-none) {
  border-style: none;
}
#agency-roster-root :is(.border-\\[\\#6E6E6E\\]) {
  --tw-border-opacity: 1;
  border-color: rgb(110 110 110 / var(--tw-border-opacity));
}
#agency-roster-root :is(.border-\\[\\#8B8B8B\\]) {
  --tw-border-opacity: 1;
  border-color: rgb(139 139 139 / var(--tw-border-opacity));
}
#agency-roster-root :is(.border-\\[\\#8b919a\\]) {
  --tw-border-opacity: 1;
  border-color: rgb(139 145 154 / var(--tw-border-opacity));
}
#agency-roster-root :is(.border-\\[\\#9B9B9B\\]) {
  --tw-border-opacity: 1;
  border-color: rgb(155 155 155 / var(--tw-border-opacity));
}
#agency-roster-root :is(.border-\\[\\#B6B6B6\\]) {
  --tw-border-opacity: 1;
  border-color: rgb(182 182 182 / var(--tw-border-opacity));
}
#agency-roster-root :is(.border-\\[\\#DE0000\\]) {
  --tw-border-opacity: 1;
  border-color: rgb(222 0 0 / var(--tw-border-opacity));
}
#agency-roster-root :is(.border-\\[\\#a2a9b0\\]) {
  --tw-border-opacity: 1;
  border-color: rgb(162 169 176 / var(--tw-border-opacity));
}
#agency-roster-root :is(.border-transparent) {
  border-color: transparent;
}
#agency-roster-root :is(.border-white) {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
#agency-roster-root :is(.border-t-transparent) {
  border-top-color: transparent;
}
#agency-roster-root :is(.\\!bg-\\[\\#eee8ff\\]) {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(238 232 255 / var(--tw-bg-opacity)) !important;
}
#agency-roster-root :is(.bg-\\[\\#282828\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(40 40 40 / var(--tw-bg-opacity));
}
#agency-roster-root :is(.bg-\\[\\#505050\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(80 80 80 / var(--tw-bg-opacity));
}
#agency-roster-root :is(.bg-\\[\\#B6B6B6\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(182 182 182 / var(--tw-bg-opacity));
}
#agency-roster-root :is(.bg-\\[\\#BDBDBD\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(189 189 189 / var(--tw-bg-opacity));
}
#agency-roster-root :is(.bg-\\[\\#D4D4D4\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 212 / var(--tw-bg-opacity));
}
#agency-roster-root :is(.bg-\\[\\#F1F1F1\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(241 241 241 / var(--tw-bg-opacity));
}
#agency-roster-root :is(.bg-\\[\\#FC4D0F\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(252 77 15 / var(--tw-bg-opacity));
}
#agency-roster-root :is(.bg-\\[\\#e7eaee\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(231 234 238 / var(--tw-bg-opacity));
}
#agency-roster-root :is(.bg-black) {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
#agency-roster-root :is(.bg-black\\/50) {
  background-color: rgb(0 0 0 / 0.5);
}
#agency-roster-root :is(.bg-transparent) {
  background-color: transparent;
}
#agency-roster-root :is(.bg-white) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
#agency-roster-root :is(.bg-white\\/70) {
  background-color: rgb(255 255 255 / 0.7);
}
#agency-roster-root :is(.bg-gradient-to-r) {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
#agency-roster-root :is(.from-transparent) {
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
#agency-roster-root :is(.via-white\\/60) {
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.6) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
#agency-roster-root :is(.to-transparent) {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
#agency-roster-root :is(.bg-center) {
  background-position: center;
}
#agency-roster-root :is(.bg-no-repeat) {
  background-repeat: no-repeat;
}
#agency-roster-root :is(.object-cover) {
  object-fit: cover;
}
#agency-roster-root :is(.p-0) {
  padding: 0px;
}
#agency-roster-root :is(.p-2) {
  padding: 0.5rem;
}
#agency-roster-root :is(.px-2) {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
#agency-roster-root :is(.px-24) {
  padding-left: 6rem;
  padding-right: 6rem;
}
#agency-roster-root :is(.px-3) {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
#agency-roster-root :is(.px-4) {
  padding-left: 1rem;
  padding-right: 1rem;
}
#agency-roster-root :is(.px-5) {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
#agency-roster-root :is(.px-6) {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
#agency-roster-root :is(.px-\\[10px\\]) {
  padding-left: 10px;
  padding-right: 10px;
}
#agency-roster-root :is(.px-\\[25\\%\\]) {
  padding-left: 25%;
  padding-right: 25%;
}
#agency-roster-root :is(.px-\\[38px\\]) {
  padding-left: 38px;
  padding-right: 38px;
}
#agency-roster-root :is(.px-\\[68px\\]) {
  padding-left: 68px;
  padding-right: 68px;
}
#agency-roster-root :is(.py-1) {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
#agency-roster-root :is(.py-1\\.5) {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
#agency-roster-root :is(.py-2) {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
#agency-roster-root :is(.py-2\\.5) {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
#agency-roster-root :is(.py-4) {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
#agency-roster-root :is(.py-6) {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
#agency-roster-root :is(.py-\\[5px\\]) {
  padding-top: 5px;
  padding-bottom: 5px;
}
#agency-roster-root :is(.py-\\[6px\\]) {
  padding-top: 6px;
  padding-bottom: 6px;
}
#agency-roster-root :is(.py-\\[9px\\]) {
  padding-top: 9px;
  padding-bottom: 9px;
}
#agency-roster-root :is(.pb-10) {
  padding-bottom: 2.5rem;
}
#agency-roster-root :is(.pb-\\[24px\\]) {
  padding-bottom: 24px;
}
#agency-roster-root :is(.pb-\\[58px\\]) {
  padding-bottom: 58px;
}
#agency-roster-root :is(.pb-\\[62px\\]) {
  padding-bottom: 62px;
}
#agency-roster-root :is(.pr-\\[70px\\]) {
  padding-right: 70px;
}
#agency-roster-root :is(.pt-1) {
  padding-top: 0.25rem;
}
#agency-roster-root :is(.pt-16) {
  padding-top: 4rem;
}
#agency-roster-root :is(.pt-6) {
  padding-top: 1.5rem;
}
#agency-roster-root :is(.pt-7) {
  padding-top: 1.75rem;
}
#agency-roster-root :is(.pt-8) {
  padding-top: 2rem;
}
#agency-roster-root :is(.text-left) {
  text-align: left;
}
#agency-roster-root :is(.text-center) {
  text-align: center;
}
#agency-roster-root :is(.text-start) {
  text-align: start;
}
#agency-roster-root :is(.font-TCCCTEXT) {
  font-family: TCCC-UnityText, ui-sans-serif, system-ui;
}
#agency-roster-root :is(.text-14) {
  font-size: 14px;
  line-height: 18px;
}
#agency-roster-root :is(.text-\\[12px\\]) {
  font-size: 12px;
}
#agency-roster-root :is(.text-\\[14px\\]) {
  font-size: 14px;
}
#agency-roster-root :is(.text-\\[16px\\]) {
  font-size: 16px;
}
#agency-roster-root :is(.text-\\[18px\\]) {
  font-size: 18px;
}
#agency-roster-root :is(.text-\\[72px\\]) {
  font-size: 72px;
}
#agency-roster-root :is(.text-base) {
  font-size: 1rem;
  line-height: 1.5rem;
}
#agency-roster-root :is(.text-sm) {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
#agency-roster-root :is(.text-xs) {
  font-size: 0.75rem;
  line-height: 1rem;
}
#agency-roster-root :is(.\\!font-medium) {
  font-weight: 500 !important;
}
#agency-roster-root :is(.font-\\[600\\]) {
  font-weight: 600;
}
#agency-roster-root :is(.font-\\[700\\]) {
  font-weight: 700;
}
#agency-roster-root :is(.font-bold) {
  font-weight: 700;
}
#agency-roster-root :is(.font-normal) {
  font-weight: 400;
}
#agency-roster-root :is(.font-semibold) {
  font-weight: 600;
}
#agency-roster-root :is(.lowercase) {
  text-transform: lowercase;
}
#agency-roster-root :is(.capitalize) {
  text-transform: capitalize;
}
#agency-roster-root :is(.leading-4) {
  line-height: 1rem;
}
#agency-roster-root :is(.leading-5) {
  line-height: 1.25rem;
}
#agency-roster-root :is(.leading-6) {
  line-height: 1.5rem;
}
#agency-roster-root :is(.leading-\\[22px\\]) {
  line-height: 22px;
}
#agency-roster-root :is(.leading-\\[28px\\]) {
  line-height: 28px;
}
#agency-roster-root :is(.tracking-wide) {
  letter-spacing: 0.025em;
}
#agency-roster-root :is(.text-\\[\\#121619\\]) {
  --tw-text-opacity: 1;
  color: rgb(18 22 25 / var(--tw-text-opacity));
}
#agency-roster-root :is(.text-\\[\\#191919\\]) {
  --tw-text-opacity: 1;
  color: rgb(25 25 25 / var(--tw-text-opacity));
}
#agency-roster-root :is(.text-\\[\\#343a3f\\]) {
  --tw-text-opacity: 1;
  color: rgb(52 58 63 / var(--tw-text-opacity));
}
#agency-roster-root :is(.text-\\[\\#4c4c4c\\]) {
  --tw-text-opacity: 1;
  color: rgb(76 76 76 / var(--tw-text-opacity));
}
#agency-roster-root :is(.text-\\[\\#505050\\]) {
  --tw-text-opacity: 1;
  color: rgb(80 80 80 / var(--tw-text-opacity));
}
#agency-roster-root :is(.text-\\[\\#5f5f5f\\]) {
  --tw-text-opacity: 1;
  color: rgb(95 95 95 / var(--tw-text-opacity));
}
#agency-roster-root :is(.text-\\[\\#8B8B8B\\]) {
  --tw-text-opacity: 1;
  color: rgb(139 139 139 / var(--tw-text-opacity));
}
#agency-roster-root :is(.text-\\[\\#8b919a\\]) {
  --tw-text-opacity: 1;
  color: rgb(139 145 154 / var(--tw-text-opacity));
}
#agency-roster-root :is(.text-\\[\\#9B9B9B\\]) {
  --tw-text-opacity: 1;
  color: rgb(155 155 155 / var(--tw-text-opacity));
}
#agency-roster-root :is(.text-\\[\\#B6B6B6\\]) {
  --tw-text-opacity: 1;
  color: rgb(182 182 182 / var(--tw-text-opacity));
}
#agency-roster-root :is(.text-\\[\\#DE0000\\]) {
  --tw-text-opacity: 1;
  color: rgb(222 0 0 / var(--tw-text-opacity));
}
#agency-roster-root :is(.text-\\[\\#a2a9b0\\]) {
  --tw-text-opacity: 1;
  color: rgb(162 169 176 / var(--tw-text-opacity));
}
#agency-roster-root :is(.text-\\[\\#c10000\\]) {
  --tw-text-opacity: 1;
  color: rgb(193 0 0 / var(--tw-text-opacity));
}
#agency-roster-root :is(.text-\\[\\#fff\\]) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
#agency-roster-root :is(.text-\\[red\\]) {
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity));
}
#agency-roster-root :is(.text-black) {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
#agency-roster-root :is(.text-white) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
#agency-roster-root :is(.underline) {
  text-decoration-line: underline;
}
#agency-roster-root :is(.decoration-solid) {
  text-decoration-style: solid;
}
#agency-roster-root :is(.accent-black) {
  accent-color: #000000;
}
#agency-roster-root :is(.opacity-0) {
  opacity: 0;
}
#agency-roster-root :is(.opacity-100) {
  opacity: 1;
}
#agency-roster-root :is(.opacity-30) {
  opacity: 0.3;
}
#agency-roster-root :is(.opacity-50) {
  opacity: 0.5;
}
#agency-roster-root :is(.shadow-lg) {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
#agency-roster-root :is(.outline-none) {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
#agency-roster-root :is(.blur) {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
#agency-roster-root :is(.filter) {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
#agency-roster-root :is(.transition-colors) {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
#agency-roster-root :is(.transition-opacity) {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
#agency-roster-root :is(.transition-transform) {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
#agency-roster-root :is(.duration-200) {
  transition-duration: 200ms;
}

::part(icon-tick) {
  background-color: black;
  border-radius: 4px;
}

::part(message) {
  font-family: TCCC-UnityText;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  color: #c10000;
}

/* This is the workaround for Brands Avatar dropdown
  in Agency Details Page */
.tippy-content .avatar-group .wpp-list-item {
  pointer-events: none;
}

body {
  font-family: 'TCCC-UnityText';
}

#agency-roster-root :is(.placeholder\\:text-\\[\\#b1b0b0\\])::placeholder {
  --tw-text-opacity: 1;
  color: rgb(177 176 176 / var(--tw-text-opacity));
}

#agency-roster-root :is(.first\\:pt-0:first-child) {
  padding-top: 0px;
}

#agency-roster-root :is(.checked\\:bg-\\[\\#000\\]:checked) {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}

#agency-roster-root :is(.hover\\:cursor-not-allowed:hover) {
  cursor: not-allowed;
}

#agency-roster-root :is(.hover\\:cursor-pointer:hover) {
  cursor: pointer;
}

#agency-roster-root :is(.hover\\:border-\\[\\#4d5358\\]:hover) {
  --tw-border-opacity: 1;
  border-color: rgb(77 83 88 / var(--tw-border-opacity));
}

#agency-roster-root :is(.hover\\:border-\\[\\#697077\\]:hover) {
  --tw-border-opacity: 1;
  border-color: rgb(105 112 119 / var(--tw-border-opacity));
}

#agency-roster-root :is(.hover\\:border-\\[\\#DE0000\\]:hover) {
  --tw-border-opacity: 1;
  border-color: rgb(222 0 0 / var(--tw-border-opacity));
}

#agency-roster-root :is(.hover\\:border-black:hover) {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

#agency-roster-root :is(.hover\\:\\!bg-\\[\\#f0f2F5\\]:hover) {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(240 242 245 / var(--tw-bg-opacity)) !important;
}

#agency-roster-root :is(.hover\\:bg-\\[\\#D4D4D4\\]:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 212 / var(--tw-bg-opacity));
}

#agency-roster-root :is(.hover\\:bg-\\[\\#e7eaee\\]:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(231 234 238 / var(--tw-bg-opacity));
}

#agency-roster-root :is(.hover\\:bg-\\[\\#f0f2F5\\]:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(240 242 245 / var(--tw-bg-opacity));
}

#agency-roster-root :is(.hover\\:bg-\\[\\#f0f2f5\\]:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(240 242 245 / var(--tw-bg-opacity));
}

#agency-roster-root :is(.hover\\:bg-\\[\\#f4f5f7\\]:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(244 245 247 / var(--tw-bg-opacity));
}

#agency-roster-root :is(.hover\\:text-\\[\\#000\\]:hover) {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

#agency-roster-root :is(.hover\\:text-\\[\\#343a3f\\]:hover) {
  --tw-text-opacity: 1;
  color: rgb(52 58 63 / var(--tw-text-opacity));
}

#agency-roster-root :is(.hover\\:text-black:hover) {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

#agency-roster-root :is(.focus\\:border-black:focus) {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

#agency-roster-root :is(.focus\\:text-\\[6E6E6E\\]:focus) {
  color: 6E6E6E;
}

#agency-roster-root :is(.focus\\:outline-none:focus) {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

#agency-roster-root :is(.focus\\:ring-\\[\\#DE0000\\]:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(222 0 0 / var(--tw-ring-opacity));
}

#agency-roster-root :is(.group:hover .group-hover\\:\\!visible) {
  visibility: visible !important;
}

#agency-roster-root :is(.group:hover .group-hover\\:\\!opacity-100) {
  opacity: 1 !important;
}

#agency-roster-root :is(.group:hover .group-hover\\:opacity-100) {
  opacity: 1;
}

#agency-roster-root :is(.\\[\\&_path\\]\\:fill-\\[\\#505050\\] path) {
  fill: #505050;
}

#agency-roster-root :is(.\\[\\&_path\\]\\:text-\\[\\#505050\\] path) {
  --tw-text-opacity: 1;
  color: rgb(80 80 80 / var(--tw-text-opacity));
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB,iEAA0B;AAA1B;;;CAA0B;AAA1B;;;EAAA,sBAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,mBAA0B,EAA1B,MAA0B;EAA1B,0BAA0B,EAA1B,MAA0B;AAAA;AAA1B;;EAAA,gBAA0B;AAAA;AAA1B;;;;;;;;CAA0B;AAA1B;;EAAA,gBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B,EAA1B,MAA0B;EAA1B,WAA0B,EAA1B,MAA0B;EAA1B,+HAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,wCAA0B,EAA1B,MAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;;;CAA0B;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,yCAA0B;UAA1B,iCAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;;;;;EAAA,kBAA0B;EAA1B,oBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,cAA0B;EAA1B,wBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,mBAA0B;AAAA;AAA1B;;;;;CAA0B;AAA1B;;;;EAAA,+GAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,cAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,cAA0B;EAA1B,cAA0B;EAA1B,kBAA0B;EAA1B,wBAA0B;AAAA;AAA1B;EAAA,eAA0B;AAAA;AAA1B;EAAA,WAA0B;AAAA;AAA1B;;;;CAA0B;AAA1B;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;EAA1B,yBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;;;CAA0B;AAA1B;;;;;EAAA,oBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B;EAA1B,gCAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,uBAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,SAA0B,EAA1B,MAA0B;EAA1B,UAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,oBAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;;;;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,aAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,gBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,wBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,YAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;EAAA,6BAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,wBAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,aAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,kBAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;;;;;;;;;;;;EAAA,SAA0B;AAAA;AAA1B;EAAA,SAA0B;EAA1B,UAA0B;AAAA;AAA1B;EAAA,UAA0B;AAAA;AAA1B;;;EAAA,gBAA0B;EAA1B,SAA0B;EAA1B,UAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,UAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,gBAA0B;AAAA;AAA1B;;;CAA0B;AAA1B;;EAAA,UAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,eAA0B;AAAA;AAA1B;;CAA0B;AAA1B;EAAA,eAA0B;AAAA;AAA1B;;;;CAA0B;AAA1B;;;;;;;;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;AAA1B;;CAA0B;AAA1B;;EAAA,eAA0B;EAA1B,YAA0B;AAAA;AAA1B,wEAA0B;AAA1B;EAAA,aAA0B;AAAA;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B;AAA0B;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B;AAA0B;AAC1B;EAAA,WAAgC;EAAhC,kBAAgC;EAAhC,iBAAgC;EAAhC,mBAAgC;EAAhC;AAAgC;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;AAAA;AAChC;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,aAA+B;EAA/B;AAA+B;AAA/B;EAAA,cAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;IAAA;EAA+B;EAA/B;IAAA;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;EAAA;IAAA;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,wBAA+B;UAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gEAA+B;EAA/B,+DAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,eAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,eAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,+EAA+B;EAA/B,mGAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,+FAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;;AAI/B;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;0BAC0B;AAC1B;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AA7BA;EAAA,oBA8BA;EA9BA;AA8BA;;AA9BA;EAAA;AA8BA;;AA9BA;EAAA,kBA8BA;EA9BA;AA8BA;;AA9BA;EAAA;AA8BA;;AA9BA;EAAA;AA8BA;;AA9BA;EAAA,sBA8BA;EA9BA;AA8BA;;AA9BA;EAAA,sBA8BA;EA9BA;AA8BA;;AA9BA;EAAA,sBA8BA;EA9BA;AA8BA;;AA9BA;EAAA,sBA8BA;EA9BA;AA8BA;;AA9BA;EAAA,6BA8BA;EA9BA;AA8BA;;AA9BA;EAAA,kBA8BA;EA9BA;AA8BA;;AA9BA;EAAA,kBA8BA;EA9BA;AA8BA;;AA9BA;EAAA,kBA8BA;EA9BA;AA8BA;;AA9BA;EAAA,kBA8BA;EA9BA;AA8BA;;AA9BA;EAAA,kBA8BA;EA9BA;AA8BA;;AA9BA;EAAA,oBA8BA;EA9BA;AA8BA;;AA9BA;EAAA,oBA8BA;EA9BA;AA8BA;;AA9BA;EAAA,oBA8BA;EA9BA;AA8BA;;AA9BA;EAAA,sBA8BA;EA9BA;AA8BA;;AA9BA;EAAA;AA8BA;;AA9BA;EAAA,8BA8BA;EA9BA;AA8BA;;AA9BA;EAAA,oBA8BA;EA9BA;AA8BA;;AA9BA;EAAA;AA8BA;;AA9BA;EAAA;AA8BA;;AA9BA;EAAA;AA8BA;;AA9BA;EAAA;AA8BA;;AA9BA;EAAA,oBA8BA;EA9BA;AA8BA","sourcesContent":["/* src/styles.css */\n@import 'tailwindcss/base';\n@import 'tailwindcss/components';\n@import 'tailwindcss/utilities';\n\n@import 'assets/css/typography';\n\n::part(icon-tick) {\n  background-color: black;\n  border-radius: 4px;\n}\n\n::part(message) {\n  font-family: TCCC-UnityText;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n  color: #c10000;\n}\n\n/* This is the workaround for Brands Avatar dropdown\n  in Agency Details Page */\n.tippy-content .avatar-group .wpp-list-item {\n  pointer-events: none;\n}\n\nbody {\n  font-family: 'TCCC-UnityText';\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
